/**
 * Path2D → straight-segment polyline. Bulge arcs (DXF tan(sweep/4) convention) are
 * tessellated at tolerance BEFORE any Clipper2 op — Clipper never sees a true arc
 * (docs/bim-plan/01-architecture.md §5).
 *
 * CURVES round: the math itself moved into bim-kernel (`arc.ts#flattenPathPts` — the
 * one shared bulge derivation, also consumed by snapping/offsets/hosted-position
 * walks); this module stays as the geometry-side entry point so every existing import
 * keeps working.
 */
import { flattenPathPts, DEFAULT_ARC_TOL_FT } from '@aj/bim-kernel'
import type { Path2D, Pt2 } from '@aj/bim-kernel'

export function flattenPath(path: Path2D, tolFt = DEFAULT_ARC_TOL_FT): Pt2[] {
  return flattenPathPts(path, tolFt)
}
